import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { PaymentModule } from './payment/payment.module';
import { DemoModule } from './demo/demo.module';
import { PagesModule } from "./pages/pages.module";
import { MatTooltipModule, MatNativeDateModule, MatIconModule } from "@angular/material";
import { StateService } from './core/state.service';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@NgModule({
    declarations: [ AppComponent ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        PaymentModule,
        DemoModule,
        PagesModule,
        MatTooltipModule,
        MatIconModule,
        MatNativeDateModule,
        HttpClientModule
    ],
    providers: [ StateService, DatePipe ],
    bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts